import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
    alignSelf: 'flex-start',
    alignItems: 'center',
    justifyContent: 'flex-start',
    textAlign: 'center',

    background: theme.palette.custom.background.area,
    boxShadow: theme.shadows[25],
    margin: `${theme.spacing(3)}px auto`,
    maxWidth: theme.spacing(80),
    overflow: 'hidden',
    maxHeight: `calc(100% - ${theme.spacing(6)})`,
    padding: theme.spacing(0, 3, 3),

    [theme.breakpoints.down('xs')]: {
      margin: theme.spacing(3, 0),
    },

    '& .send-success': {
      '&-title': {
        color: theme.palette.text.secondary,
        padding: theme.spacing(6, 0),
      },
      '&-icon': {
        fontSize: theme.spacing(8),
        color: theme.palette.custom.feedback.positive,
      },
      '&-message': {
        color: theme.palette.text.secondary,
        margin: theme.spacing(2, 0),
        maxWidth: theme.spacing(40),
      },
      '&-list-infos': {
        '&-container': {
          listStyle: 'none',
          padding: theme.spacing(2, 0),
          maxWidth: theme.spacing(60),
        },
        '&-item': {
          '&-container': {
            display: 'flex',
            alignItems: 'flex-start',
            marginBottom: theme.spacing(3),
          },
          '&-icon': {
            color: theme.palette.custom.feedback.positive,
            marginRight: theme.spacing(1),
          },
          '&-text': {
            color: theme.palette.text.secondary,
            textAlign: 'left',
          },
        },
      },
      '&-button-history': {
        marginBottom: theme.spacing(3),
      },
      '&-button-new': {
        marginBottom: theme.spacing(3),
      },
    },
  },
}));

export default styles;
